import cn from "classnames";
import React from "react";
import styles from "./styles.module.scss";

const FeminineHighlight = ({ bold = false, className, children = "female-coded" }) => (
  <span className={cn(styles.highlight, styles.feminine, className, { [styles.bold]: bold })}>
    {children}
  </span>
);

export default FeminineHighlight;
